<template>
    <div class="consul-deal clearfix" style="position:relative;">
        <div class="deal-content marginP " >
            <div class="part-right consul-deal-part mypatient" v-loading="!isSuccess">
                <div class="evaluate-wrap consul-sheet-wrap deal-sheet-wrap" v-if="isSuccess">
                    <div>
                        <ImageAmplify/>
                        <div class="video-Top">
                            <label class="searchTip" style="color:#92412B;">状态 :{{consultDetail.consultStatusDescription}}</label>
                            <!--<label v-if="consultStatus=='CANCEL'&&consultDetail.consult.modifierType=='ASS'" class="fee-num lineH40">（已拒绝）</label>-->
                            <!--<label v-if="consultStatus=='CANCEL'" class="fee-num lineH40">（已取消）</label>-->
                        </div>
                        <div class=" clearfix" style="background:#fff;margin-top:10px;">
                                <div class="launch-title1" style="background: #F9F9F9;">
                                    <p>基本信息</p>
                                </div>
                                <div style="box-sizing: border-box;padding:0px 20px;" class="box-borders">
                                    <div style="height:36px;box-sizing: border-box;line-height: 36px;">
                                        <label class="fl order-num jet-black">NO.{{ consultDetail.consultGroup.consultGroupNo }}</label>
                                        <label class="fr order-num jet-black">问诊费用：<span class="fee-num">￥{{ consultDetail.consultGroup.consultFee }}</span></label>
                                    </div>
                                    <div class="clearfix" style="height:36px;">
                                        <span class="name patient-list-item jet-black lineH30 fontSize14">{{ consultDetail.consultGroup.consulterName }}</span>
                                        <span class="patient-list-item lineH30 jet-gray">{{ consultDetail.consultGroup.consulterGender =="M"?"男":"女" }}</span>
                                        <span class="patient-list-item lineH30 jet-gray">{{ consultDetail.consultGroup.consulterAge }}岁</span>
                                        <span class="patient-list-item lineH30 jet-gray">患者病历号：{{consultDetail.consultGroup.consulterInhosno}}</span>
                                    </div>
                                    <div class="clearfix" style="height:36px;">
                                        <span class="patient-list-item lineH30 jet-gray">电话号码：{{ consultDetail.consultGroup.consulterMobile }}</span>
                                        <span class="patient-list-item lineH30 jet-gray">身份证：{{ consultDetail.consultGroup.consulterIdcard }}</span>
                                        <span class="patient-list-item lineH30 jet-gray">职业：{{consultDetail.consultGroup.consulterJob?consultDetail.consultGroup.consulterJob:"无"}}</span>
                                        <span class="patient-list-item lineH30 jet-gray">婚姻：{{maritalStatus}}</span>
                                    </div>
                                    <div class="clearfix" style="height:36px;">
                                        <span class="patient-list-item lineH30 jet-gray">家庭住址：{{consultDetail.areaNameArr[0]}}</span>
                                        <span class="patient-list-item lineH30 jet-gray">{{consultDetail.areaNameArr[1]}}</span>
                                        <span class="patient-list-item lineH30 jet-gray">{{consultDetail.areaNameArr[2]}}</span>
                                        <span class="patient-list-item lineH30 jet-gray">{{consultDetail.consultGroup.consulterAddress}}</span>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div class="launch-title1" style="margin-top:10px;background: #F9F9F9;">
                        <p>简要病史（申请医生填写）</p>
                    </div>
                    <div style="box-sizing: border-box;padding:10px 20px;background: #fff;" class="box-borders">
                        <div>
                            <div class="lineH22 marginB10">
                                <span class="jet-gray">患者主诉：</span>
                                <div class="linecon">
                                    {{ consultDetail.consultGroup.consultContent }}
                                </div>
                            </div>
                            <div class="lineH22 marginB10">
                                <span class="jet-gray">初步诊断：</span>
                                <div class="linecon">
                                    {{ beforeDiagnose }}
                                </div>
                            </div>
                            <div class="lineH22 marginB10">
                                <span class="jet-gray">会诊目的：</span>
                                <div class="linecon">
                                    {{ consultDetail.consultGroup.consultReason }}
                                </div>
                            </div>
                        </div>
                        <div class="add-pic-list">
                            <span class="jet-gray">病历附件：</span>
                            <!--<el-button size="small" style="margin-left:25px;" type="ghost"  @click="linkToCx" class="ghost-btn">电子病历</el-button>-->
                        </div>
                        <div style="margin-left:75px;margin-top:10px;">
                            <img v-for="(item,index) in imgList" class="item-pic w88 h88" :src="item.attaFileUrl" :key="index" @click="handleImageAmplify(index, imgList, $evnet)" style="margin-left:10px;">
                        </div>
                        <ul class="el-upload-list el-upload-list--text" style="margin-left:75px;margin-top:10px;">
                            <li class="el-upload-list__item is-success" v-for="(item, index) in fileList" :key="index">
                                <a class="el-upload-list__item-name" :href="item.attaFileUrl" target="_blank">
                                    <i class="el-icon-document"></i>
                                    {{ item.attaFileName }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div v-if="consultStatus!='CANCEL'">
                        <div class="launch-title1" style="margin-top:10px;background: #F9F9F9;">
                            <p>会诊申请信息</p>
                        </div>
                        <div style="box-sizing: border-box;padding:10px 20px;background: #fff;">
                            <div class="lineH22 marginB10 Allnews">
                                <span class="jet-gray">申请类型：<span style="color:#333333;">{{ consultDetail.consultGroup.consultGroupType }}</span></span>
                                <span class="jet-gray " style="position:absolute;left:200px;" >辅助诊断类型：<span style="color:#333333;">{{ consultDetail.consultGroup.auxiliaryDiagnose }}</span></span>
                            </div>
                            <div class=" marginB10 paddingT10 Allnews">
                                <span class="jet-gray">期望会诊医院：<span style="color:#333333;">{{ consultDetail.consultGroup.hopeHosName?consultDetail.consultGroup.hopeHosName:consultDetail.consultGroup.acceptHosName }}</span></span>
                                <span class="jet-gray" style="position:absolute;left:300px;" >期望会诊科室：<span style="color:#333333;">{{ consultDetail.consultGroup.hopeDeptName?consultDetail.consultGroup.hopeDeptName:consultDetail.consultGroup.acceptDeptName }}</span></span>
                                <span class="jet-gray" style="position:absolute;left:480px;" >期望会诊医生：<span style="color:#333333;">{{ consultDetail.consultGroup.hopeDocName?consultDetail.consultGroup.hopeDocName:consultDetail.consultGroup.acceptDocName }}</span></span>
                                <span class="jet-gray marginL20" style="position:absolute;left:650px;">邀请会诊时间：<span style="color:#333333;">{{consultDetail.consultGroup.hopeTime?consultDetail.consultGroup.hopeTime:'无'}}</span></span>
                            </div>
                            <div class=" marginB10 paddingT10 Allnews">
                                <span class="jet-gray">申请医院：<span style="color:#333333;">{{ consultDetail.consultGroup.initHosName}}</span></span>
                                <span class="jet-gray" style="position:absolute;left:300px;" >申请科室：<span style="color:#333333;">{{ consultDetail.consultGroup.initDeptName}}</span></span>
                                <span class="jet-gray" style="position:absolute;left:480px;">申请医生：<span style="color:#333333;">{{ consultDetail.consultGroup.initDocName}}</span></span>
                                <span class="jet-gray marginL20" style="position:absolute;left:650px;">申请时间：<span style="color:#333333;">{{ formatUnix(consultDetail.consultGroup.createTime) }}</span></span>
                            </div>
                        </div>
                        <div class="launch-title1 ghost-btn-wrap" style="margin-top:10px;background: #F9F9F9;position:relative;">
                            <p>会诊情况</p>
                            <!--<el-button-->
                                    <!--size="small"-->
                                    <!--style="position:absolute;right:100px;top:5px;"-->
                                    <!--type="ghost"-->
                                    <!--v-show="shows6"-->
                                    <!--@click="getHosTransfer1"-->
                                    <!--class="ghost-btn">门诊转诊-->
                            <!--</el-button>-->
                            <!--<el-button-->
                                    <!--size="small"-->
                                    <!--style="position:absolute;right:20px;top:5px;"-->
                                    <!--type="ghost"-->
                                    <!--v-show="shows6"-->
                                    <!--@click="getHosTransfer"-->
                                    <!--class="ghost-btn">住院转诊-->
                            <!--</el-button>-->
                        </div>
                        <div class="opinionPart sheet-content evaluate-launch-wrap " style="box-sizing: border-box;padding:10px 20px;background: #fff;">
                            <div class="opinionPart sheet-content evaluate-launch-wrap marginT10 clearfix">
                                <div class="lineH22 marginB10 fl">
                                    <span class="jet-gray" style="font-size: 12px;color:#000000;">会诊医生：</span>     {{ consultDetail.consultGroup.acceptHosName+' - '+consultDetail.consultGroup.acceptDeptName+' - '+consultDetail.consultGroup.acceptDocName}}
                                </div>
                                <div class="lineH22 marginB10 fl marginL20">
                                    <span class="jet-gray" style="font-size: 12px;color:#000000;">会诊时间：</span>{{ videoTime }}
                                </div>
                            </div>
                            <div class="opinionPart  evaluate-launch-wrap  clearfix">
                                <label><span class="fee-num"></span>患者病情情况：</label>
                                <el-select v-model="consulterDiagnoseLevel" size="small" style="width:100px;" class="w60 h24 launch-input">
                                    <el-option label="一般" value="0"/>
                                    <el-option label="严重" value="1"/>
                                </el-select>
                                <label v-show="shows6"><span class="fee-num"></span>是否建议转诊：</label>
                                <el-select v-show="shows6" v-model="transFer" size="small" style="width:100px;" class="w60 h24 launch-input">
                                    <el-option label="是" value="0"/>
                                    <el-option label="否" value="1"/>
                                </el-select>
                                <el-button
                                        size="small"
                                        type="ghost"
                                        v-if="transFer=='0'"
                                        style="margin-left:10px;"
                                        @click="getHosTransfer1"
                                        class="ghost-btn">门诊转诊
                                </el-button>
                                <el-button
                                        size="small"
                                        type="ghost"
                                        v-if="transFer=='0'"
                                        style="margin-left:10px;"
                                        @click="getHosTransfer"
                                        class="ghost-btn">急诊转诊
                                </el-button>
                                <el-button
                                        size="small"
                                        type="ghost"
                                        v-if="transFer=='0'"
                                        style="margin-left:10px;"
                                        @click="getHosTransfer2"
                                        class="ghost-btn">住院转诊
                                </el-button>
                            </div>
                            <el-form  label-position="left" label-width="85px" style="margin-top:10px;">
                                <el-form-item label="咨询意见：">
                                    <el-input  v-model="consultAdvice" :rows="4" type="textarea" class="h88 w560"  :disabled="mark=='init'"></el-input>
                                </el-form-item>
                                <el-form-item label="会诊后诊断：">
                                    <el-input  v-model="evaluateData.afterDiagnose" type="textarea" class="h49 w560" :disabled="mark=='init'"></el-input>
                                </el-form-item>
                                <el-form-item label="患者转诊情况：">
                                    <span>{{zzqk?zzqk:"暂未转诊"}}</span>
                                </el-form-item>
                                <el-form-item label="咨询意见附件：">
                                    <div class="add-pic-list fl">
                                        <ul class="el-upload-list--picture-card el-upload-list">
                                            <li class="el-upload-list__item " v-for="(item,index) in adviceImgList" :key="index">
                                                <img  class="el-upload-list__item-thumbnail" :src="item.attaFileUrl" @click="handleImageAmplify(index, adviceImgList, $event)">
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="add-pic-list fl" v-show="shows6">
                                        <!--<img v-for="(item,index) in adviceImgList" class="item-pic w88 h88 marginR10" :src="item.url" :key="index" @click="handleImageAmplify">-->
                                        <el-upload
                                            :action="uploadUrl"
                                            :data="uploadData"
                                            :headers={sign:PasWord()}
                                            list-type="picture-card"
                                            :before-upload="beforeUpload"
                                            accept="image/gif,image/jpg,image/jpeg,image/png,image/bmp"
                                            :on-success="onSuccessImg"
                                            class="fl"
                                            type="select"
                                            ref="uploadRef"
                                            :on-remove="onRemoveImg"
                                            :file-list="imgUploadList"
                                            :on-preview="handlePreview">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                    </div>
                                </el-form-item>
                                <p class="marginT15"  v-show="shows6" style="color:#afafaf;margin-left:80px;">支持jpg、png、gif、bmp格式。</p>
                                <el-form-item label-position="right"class="marginT10"  v-show="shows6">
                                    <div class="ghost-btn-wrap">
                                        <el-upload
                                                :action="uploadUrl"
                                                :data="uploadData"
                                                :before-upload="beforeUploadFile"
                                                :on-success="onSuccessFile"
                                                :on-remove="onRemoveFile"
                                                :file-list="fileUploadList">
                                            <el-button size="small" type="ghost" class="ghost-btn" style="color: #999999; border-color: #999999"><i class="el-icon-upload el-icon--left"></i>添加附件</el-button>
                                        </el-upload>
                                    </div>
                                </el-form-item>
                                <ul class="el-upload-list el-upload-list--text" style="margin-top:10px;margin-left:80px;">
                                    <li class="el-upload-list__item is-success" v-for="(item, index) in adviceFileList" :key="index">
                                        <a class="el-upload-list__item-name" :href="item.attaFileUrl" target="_blank">
                                            <i class="el-icon-document"></i>
                                            {{ item.attaFileName }}
                                        </a>
                                    </li>
                                </ul>
                                <p class="marginT10"  v-show="shows6" style="color:#afafaf;margin-left:80px;">仅支持pdf、xls、xlsx、doc、docx、txt、rar、zip、PDF格式，文件小于500M。</p>
                            </el-form>
                        </div>
                        <!--<div class="ssts1" style="position:relative;top: 0;left: 0;bottom: 0;right: 0;margin: auto;background: #F9F9F9;" v-show="showPj">-->
                            <!--<p>评价情况</p>-->
                        <!--</div>-->

                        <!--去评价弹窗-->
                        <div class="ssts1" style="height: 490px;padding-top: 40px;" v-show="showPj">
                            <el-form  label-position="left" label-width="200px">
                                <el-form-item label="会诊前后诊断符合情况" v-show="shows6" style="padding: 0px 60px;">
                                    <el-select v-model="evaluateData.equalDiagnose" size="small" class="launch-input w120 h24" >
                                        <el-option label="符合" value="1"/>
                                        <el-option label="不符合" value="0"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="对方系统运行效果评价" v-show="!shows6" style="padding: 0px 60px;">
                                    <el-select v-model="evaluateData.systemScore" size="small" class="launch-input w120 h24" >
                                        <el-option label="优" value="优"/>
                                        <el-option label="良" value="良"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="对方病历质量评价" v-show="shows6" style="padding: 0px 60px;">
                                    <el-select v-model="evaluateData.medicalScore" size="small" class="launch-input w120 h24" >
                                        <el-option label="优" value="优"/>
                                        <el-option label="良" value="良"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="对方辅助诊断资料质量评价" v-show="shows6" style="padding: 0px 60px;">
                                    <el-select v-model="evaluateData.recordScore" size="small" class="launch-input w120 h24" >
                                        <el-option label="优" value="优"/>
                                        <el-option label="良" value="良"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="对方病史复述能力评价" v-show="shows6" style="padding: 0px 60px;">
                                   <el-select v-model="evaluateData.pastHistoryScore" size="small" class="launch-input w120 h24" >
                                       <el-option label="优" value="优"/>
                                       <el-option label="良" value="良"/>
                                   </el-select>
                                </el-form-item>
                            </el-form>
                            <div class="consul-form-item h60 bgc-white marginB20" style="padding: 0px 60px;">
                                <div>
                                    <label class="light-gray">处理时间：</label>
                                    <span class="label-content light-gray">{{ formatUnix(consultDetail.consultGroup.modifyTime)}}</span>
                                </div>
                                <div>
                                    <label class="light-gray">处理人：</label>
                                    <span class="light-gray">{{ consultDetail.consultGroup.acceptHosName+' - '+consultDetail.consultGroup.acceptDeptName+' - '+consultDetail.consultGroup.acceptDocName }}</span>
                                </div>
                            </div>
                            <div class="consul-form-item h30 bgc-white marginB20 margint60">
                                <el-button
                                        type="primary"
                                        class=" blue-btn h36 w200"
                                        @click="cancelEvaluate"
                                        :loading="submits1"
                                        style="margin-top:20px;text-align: center;margin-left: 50px;background-color: #FFFFFF;border-color: #5B2819;color: #5B2819;">
                                    取消
                                </el-button>
                                <el-button
                                        type="primary"
                                        class=" blue-btn h36 w200 "
                                        :disabled="zt"
                                        @click="submitEvaluate1"
                                        :loading="submits1"
                                        style="margin-top:20px;text-align: center;margin-left: 10px">
                                    提交评价
                                </el-button>
                            </div>

                            <!--查看评价情况弹窗-->
                        </div>
                        <div class="ssts1" style="height: 490px; padding-top: 40px;" v-show="showPj2">
                            <el-form  label-position="left" label-width="200px">
                                <el-form-item label="会诊前后诊断符合情况" v-show="shows6" style="padding: 0px 60px;">
                                    <el-select v-model="evaluateData.equalDiagnose" size="small" class="launch-input w120 h24" disabled="disabled">
                                        <el-option label="符合" value="1"/>
                                        <el-option label="不符合" value="0"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="对方系统运行效果评价" v-show="!shows6" style="padding: 0px 60px;">
                                    <el-select v-model="evaluateData.systemScore" size="small" class="launch-input w120 h24" disabled="disabled">
                                        <el-option label="优" value="优"/>
                                        <el-option label="良" value="良"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="对方病历质量评价" v-show="shows6" style="padding: 0px 60px;">
                                    <el-select v-model="evaluateData.medicalScore" size="small" class="launch-input w120 h24" disabled="disabled">
                                        <el-option label="优" value="优"/>
                                        <el-option label="良" value="良"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="对方辅助诊断资料质量评价" v-show="shows6" style="padding: 0px 60px;">
                                    <el-select v-model="evaluateData.recordScore" size="small" class="launch-input w120 h24" disabled="disabled">
                                        <el-option label="优" value="优"/>
                                        <el-option label="良" value="良"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="对方病史复述能力评价" v-show="shows6" style="padding: 0px 60px;">
                                   <el-select v-model="evaluateData.pastHistoryScore" size="small" class="launch-input w120 h24" disabled="disabled">
                                       <el-option label="优" value="优"/>
                                       <el-option label="良" value="良"/>
                                   </el-select>
                                </el-form-item>
                            </el-form>
                            <div class="consul-form-item h60 bgc-white marginB20" style="padding: 0px 60px;">
                                <div class="fr">
                                    <label class="light-gray">处理时间：</label>
                                    <span class="label-content light-gray">{{ formatUnix(consultDetail.consultGroup.modifyTime)}}</span>
                                    <label class="light-gray">处理人：</label>
                                    <span class="light-gray">{{ consultDetail.consultGroup.acceptHosName+' - '+consultDetail.consultGroup.acceptDeptName+' - '+consultDetail.consultGroup.acceptDocName }}</span>
                                </div>
                            </div>
                            <div class="consul-form-item h30 bgc-white marginB20 margint60" style="text-align: center;">
                                <el-button
                                        type="primary"
                                        class=" blue-btn h36 w200"
                                        @click="cancelEvaluate"
                                        :loading="submits1"
                                        style="text-align: center;background-color: #FFFFFF;border-color: #5B2819;color: #5B2819;">
                                    返回
                                </el-button>
                            </div>

                        </div>
                        <div class="border-box blue-btn-wrap" style="height:50px;">
                            <div style=" width:420px;margin:0 auto;display: flex;flex-direction: row;align-items: center">
                                <el-button
                                        type="primary"
                                        v-if="isAcceptDoc"
                                        class=" blue-btn h36 w200 "
                                        @click="submitEvaluate"
                                        :loading="submits"
                                        style="margin-top:20px;text-align: center;margin-right: 10px;">
                                    提交会诊情况
                                </el-button>
                                <el-button
                                        type="primary"
                                        class=" blue-btn h36 w200 "
                                        @click="toEvaluate"
                                        v-if="!pjRes&&!consultDetail.consultGroup.recordScore&&!consultDetail.consultGroup.systemScore"
                                        :loading="submits1"
                                        style="margin-top:20px;text-align: center;margin-right: 10px;">
                                    评价
                                </el-button>

                                <el-button
                                        type="primary"
                                        class=" blue-btn h36 w200 "
                                        @click="evaluateView"
                                        v-if="pjRes||consultDetail.consultGroup.recordScore||consultDetail.consultGroup.systemScore"
                                        :loading="submits1"
                                        style="margin-top:20px;text-align: center;margin:20px auto 0;">
                                    查看评价
                                </el-button>

                                <!--@click="submitEvaluate1"-->
                            </div>
                        </div>
                    </div>

                    <div v-if="consultStatus=='CANCEL'">
                        <div class="launch-title1" style="margin-top:10px;background: #F9F9F9;">
                            <p>取消信息</p>
                        </div>
                        <div class="box-borders" style="padding:0;">
                            <div class="opinionPart  evaluate-launch-wrap  clearfix">
                                <div class="lineH22 " style="box-sizing: border-box;padding:0px 20px;background: #fff;height:30px;line-height: 30px;">
                                    <span class="jet-gray">取消理由：</span><span class="fee-num">{{ consultDetail.consultGroup.disagreeReason?consultDetail.consultGroup.disagreeReason:'' }}</span>
                                </div>
                                <div class="consul-form-item h30 bgc-white marginB20">
                                    <div class="fr">
                                        <label class="light-gray">处理时间：</label>
                                        <span class="label-content light-gray">{{ formatUnix(consultDetail.consultGroup.modifyTime)}}</span>
                                        <label class="light-gray">处理人：</label>
                                        <span class="light-gray">{{ modifyName }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--急诊转诊-->
            <!--急诊转诊提示-->
            <div class="ssts1 ghost-btn-wrap" v-show="showBox1">
                <div style="width:100%;height:65px;position:relative;">
                    <img class="imgposition" src="../../../images/transfer.png" alt="">
                </div>
                <div style="margin-top:20px;">
                    <p style="color:#333;text-align: center;font-weight: bold;">是否确定为该患者申请急诊转诊？</p>
                </div>
                <div style="margin-top:30px;width:70%;margin-left:15%;">
                    <p style="color:#8A8A8A;text-align: center;font-size: 14px;line-height:24px;">提示：对于异地转诊患者，如是初诊患者，系统会对其进行实名认证，通过后在线建档。</p>
                </div>
                <div style="margin-top:20px;">
                    <el-select
                            v-model="initHosId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            placeholder="请选择申请医院"
                            @change="getInitHospId">
                        <el-option v-for="item in hospListZ" :label="item.yymc" :value="item.yyid" :key="item.yyid"/>
                    </el-select>
                    <el-select
                            v-model="initDeptId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            @visible-change="getInitDeptList"
                            @change="getInitDeptId"
                            :loading="loading"
                            placeholder="请选择申请科室">
                        <el-option v-for="item in initDeptList" :label="item.ksmc" :value="item.ksid" :key="item.ksid"/>
                    </el-select>
                    <el-select
                            v-model="initDocId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            @visible-change="getInitDocList"
                            @change="getInitDocId"
                            placeholder="请选择申请医生">
                        <el-option v-for="item in initDocList" :label="item.ysxm" :value="item.ysid" :key="item.ysid"/>
                    </el-select>
                </div>
                <!--<div  style="margin-top:20px;width:70%;margin-left:15%;">-->
                    <!--<p @click="showjpg" style="cursor:pointer;color:#92412B;text-decoration:underline;text-align: center;font-size: 14px;line-height:24px;">住院转诊:查看认证，建档流程.jpg</p>-->
                <!--</div>-->
                <div style="position:relative;margin-top:50px;">
                    <el-button
                            type="ghost"
                            style="position:absolute;width:150px;left:50px;top:0;"
                            @click="closeBox"
                            class="ghost-btn">返回
                    </el-button>
                    <el-button
                            type="primary"
                            class="submit-btn blue-btn h36 w200 "
                            @click="SureTransf"
                            style="position:absolute;right:50px;top:0;">
                        确定转诊，获取病案号
                    </el-button>
                </div>
            </div>
            <!--住院转诊提示-->
            <div class="ssts1 ghost-btn-wrap" v-show="showBox6">
                <div style="width:100%;height:65px;position:relative;">
                    <img class="imgposition" src="../../../images/transfer.png" alt="">
                </div>
                <div style="margin-top:20px;">
                    <p style="color:#333;text-align: center;font-weight: bold;">是否确定为该患者申请住院转诊？</p>
                </div>
                <div style="margin-top:30px;width:70%;margin-left:15%;">
                    <p style="color:#8A8A8A;text-align: center;font-size: 14px;line-height:24px;">提示：对于异地转诊患者，如是初诊患者，系统会对其进行实名认证，通过后在线建档。</p>
                </div>
                <div style="margin-top:20px;">
                    <el-select
                            v-model="initHosId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            placeholder="请选择申请医院"
                            @change="getInitHospId">
                        <el-option v-for="item in hospListZ" :label="item.yymc" :value="item.yyid" :key="item.yyid"/>
                    </el-select>
                    <el-select
                            v-model="initDeptId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            @visible-change="getInitDeptList"
                            @change="getInitDeptId"
                            :loading="loading"
                            placeholder="请选择申请科室">
                        <el-option v-for="item in initDeptList" :label="item.ksmc" :value="item.ksid" :key="item.ksid"/>
                    </el-select>
                    <el-select
                            v-model="initDocId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            @visible-change="getInitDocList"
                            @change="getInitDocId"
                            placeholder="请选择申请医生">
                        <el-option v-for="item in initDocList" :label="item.ysxm" :value="item.ysid" :key="item.ysid"/>
                    </el-select>
                </div>
                <!--<div  style="margin-top:20px;width:70%;margin-left:15%;">-->
                    <!--<p @click="showjpg" style="cursor:pointer;color:#92412B;text-decoration:underline;text-align: center;font-size: 14px;line-height:24px;">住院转诊:查看认证，建档流程.jpg</p>-->
                <!--</div>-->
                <div style="position:relative;margin-top:50px;">
                    <el-button
                            type="ghost"
                            style="position:absolute;width:150px;left:50px;top:0;"
                            @click="closeBox"
                            class="ghost-btn">返回
                    </el-button>
                    <el-button
                            type="primary"
                            class="submit-btn blue-btn h36 w200 "
                            @click="SureTransf"
                            style="position:absolute;right:50px;top:0;">
                        确定转诊，获取病案号
                    </el-button>
                </div>
            </div>
            <!--急诊转诊成功-->
            <div class="ssts2 ghost-btn-wrap" v-show="showBox2">
                    <div style="background:#ccc;width:90px;height:90px;position:absolute;left:0;right:0;top:20px;margin: 0 auto;">
                        <img src="../../../images/success.png" alt="">
                    </div>
                    <div style="margin-top:130px;width:60%;margin-left:20%;">
                          <p style="text-align: center;">该患者建档成功</p>
                    </div>
                    <div style="margin-top:30px;width:50%;margin-left:25%;">
                          <p style="text-align: center;">该患者在本院的病案号为:</p>
                    </div>
                    <div style="margin-top:30px;width:50%;margin-left:25%;">
                        <p style="text-align: center;">{{bah}}</p>
                    </div>
                        <el-button
                                type="ghost"
                                style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                                @click="closeBox2"
                                class="ghost-btn">我知道了
                        </el-button>
            </div>
            <!--急诊转诊失败-->
             <div class="ssts4" v-show="showBox4">
                 <div style="background:#ccc;width:90px;height:90px;position:absolute;left:0;right:0;top:20px;margin: 0 auto;">
                     <img src="../../../images/error.png" alt="">
                 </div>
                 <div style="margin-top:100px;width:60%;margin-left:20%;">
                     <p style="text-align: center;">病案号获取失败</p>
                 </div>
                 <div style="margin-top:30px;width:70%;margin-left:15%;">
                     <p style="text-align: center;">{{bahms}}</p>
                 </div>
                 <el-button
                         type="ghost"
                         style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                         @click="closeBox4"
                         class="ghost-btn">我知道了
                 </el-button>
             </div>
            <!--急诊转诊已有病案号-->
            <div class="ssts2 ghost-btn-wrap" v-show="showBox5">
                <div style="background:#ccc;width:90px;height:90px;position:absolute;left:0;right:0;top:20px;margin: 0 auto;">
                    <img src="../../../images/success.png" alt="">
                </div>
                <div style="margin-top:100px;width:60%;margin-left:20%;">
                    <p style="text-align: center;">该患者在该院已有病案号</p>
                </div>
                <div style="margin-top:30px;width:50%;margin-left:25%;">
                    <p style="text-align: center;">该患者在本院的病案号为:</p>
                </div>
                <div style="margin-top:30px;width:50%;margin-left:25%;">
                    <p style="text-align: center;">{{bah}}</p>
                </div>
                <el-button
                        type="ghost"
                        style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                        @click="closeBox5"
                        class="ghost-btn">我知道了
                </el-button>
            </div>
            <!--急诊转诊流程图提示-->
            <div class="ssts3 ghost-btn-wrap" v-show="showBox3" >
                <img src="../../../images/arranges.png" alt="" style="width:100%;height:90%;">
                <el-button
                        type="ghost"
                        style="position:absolute;width:150px;left:0;right:0;bottom:20px;margin:0 auto;"
                        @click="closeBox3"
                        class="ghost-btn">返回
                </el-button>
            </div>

            <!--门诊转诊-->

            <!--门诊转诊提示-->
            <div class="ssts1 ghost-btn-wrap" v-show="showBoxs1" style="z-index:777;">
                <div style="width:100%;height:65px;position:relative;">
                    <img class="imgposition" src="../../../images/transfer.png" alt="">
                </div>
                <div style="margin-top:20px;">
                    <p style="color:#333;text-align: center;font-weight: bold;">是否确定为该患者加号？</p>
                </div>
                <div style="margin-top:30px;width:70%;margin-left:15%;">
                    <p style="color:#8A8A8A;text-align: center;font-size: 14px;line-height:24px;">提示：对于异地转诊患者，如是复诊患者，可直接加号；如是初诊患者，系统会对患者进行实名认证，认证通过后在线建档，再加号。</p>
                </div>
                <div style="margin-top:20px;">
                    <el-select
                            v-model="initHosId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            placeholder="请选择申请医院"
                            @change="getInitHospId">
                        <el-option v-for="item in hospListZ" :label="item.yymc" :value="item.yyid" :key="item.yyid"/>
                    </el-select>
                    <el-select
                            v-model="initDeptId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            @visible-change="getInitDeptList"
                            @change="getInitDeptId"
                            :loading="loading"
                            placeholder="请选择申请科室">
                        <el-option v-for="item in initDeptList" :label="item.ksmc" :value="item.ksid" :key="item.ksid"/>
                    </el-select>
                    <el-select
                            v-model="initDocId"
                            size="small"
                            style="margin-left:5px;"
                            class="launch-input w150 h24"
                            filterable
                            :loading="loading"
                            @visible-change="getInitDocList"
                            @change="getInitDocId"
                            placeholder="请选择申请医生">
                        <el-option v-for="item in initDocList" :label="item.ysxm" :value="item.ysid" :key="item.ysid"/>
                    </el-select>
                </div>
                <div style="position:relative;margin-top:50px;">
                    <el-button
                            type="ghost"
                            style="position:absolute;width:150px;left:50px;top:0;"
                            @click="closeBoxs1"
                            class="ghost-btn">返回
                    </el-button>
                    <el-button
                            type="primary"
                            class="submit-btn blue-btn h36 w200 "
                            @click="SureTransf1"
                            style="position:absolute;right:50px;top:0;">
                            加号
                    </el-button>
                </div>
            </div>
            <div class="ssts" v-show="showBox">

            </div>

            </div>
        <router-view></router-view>
    </div>
</template>
<style>

</style>
<script>
    import ConsultationSheet from "./ConsultationSheet.vue";
    import { Message ,Select,Input, Option, DatePicker,} from "element-ui";
    import ImageAmplify from "../common/ImageAmplify.vue";
    import fileClassification from "../../utils/FileClassificationUtils.js";
    import axiosUtil from "../../utils/AxiosUtils.js";
    import axiosUtilz from "../../utils/AxiosUtilz.js";
    import { API_URL } from "../../data/Url";
    import {imageAmplify} from "../../utils/ImageAmplify.js";
    import { formatUnixTime } from "../../utils/DateFormat.js";
    import { upLoadBasicParam } from "../../data/basicParam.js";
    const upLoadFileCountMax = 9;//最大上传数量
    import Vue from "vue";
    Vue.use(Input);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(DatePicker);
    export default{
        data(){
            return{
                zt:false,
                maritalStatus:"",
                zs:'',
                kh:"",
                lxdz:"",
                areaNameArr:[],
                hy:"",
                transFer:"",
                bahms:"",
                beforeDiagnose:"",
                showBoxs1:false,
                zzqk:"",
                bah:"",
                showBox5:false,
                showBox4:false,
                showBox3:false,
                initDocId:"",
                initHosId:"",
                initDeptId:"",
                initDocList:[],
                initDeptList:[],
                hospListZ:[],
                ywlx:"",
                showBox2:false,
                showBox1:false,
                showBox6:false,
                showBox:false,
                submits:false,
                submits1:false,
                loading:false,
                consulterIdcard:"",
                isAdviseds:false,
                sst1:"",
                showTranfer:"",
                consultStatusDescription:"",
                consultDetail:null,//会诊单详细数据
                isSuccess: false,//数据是否加载成功
                consultAdvice:"",
                evaluateData: {
                    equalDiagnose: "1",//会诊前后诊断符合情况
                    transfer: "0",//是否建议转诊
                    medicalScore: "优",//对方病历质量评价
                    recordScore: "优",//对方辅助诊断资料质量评价
                    pastHistoryScore: "优",//对方病史复述能力评价
                    afterDiagnose: "",//会诊后诊断
                    systemScore: "优"//对方系统运行效果评价
                },
                pjRes:false,//是否提交评价
                shows6:true,
                showBox:false,//遮罩层
                showPj:false,//评价显示
                showPj2:false,//查看评价弹框
                imgList: [],//附件图片列表
                fileList: [],//附件文件列表
                /*上传图片*/
                adviceImgList: [],// 咨询意见图片
                adviceFileList: [],// 咨询意见附件
                uploadFileCount: 0,//上传的文件数量，最大为9个
                uploadData: {},//up-load组件的data数据
                imgUploadList: [],//需上传的图片列表
                fileUploadList: [],//需上传的文件列表
                attaIdList: [],//需要提交的附件列表
                uploadUrl: API_URL,//上传图片action地址
                acceptId:"",
//                isAdvised:true,
                mark:localStorage.getItem('hosMark'),
                consulterName:"",
                consulterMobile:"",
                consulterJob:"",
                hzsqyymc:"",
                hzsqksmc:"",
                hzsqysxm:"",
                consulterDiagnoseLevel:"",
                hzyyid:"",
                zyyymc:"",
                zyyyid:"",
                zyksmc:"",
                zyysxm:"",
                hzyymc:"",
                hzksmc:"",
                hzysxm:"",
                hzysid:"",
                hzsj:"",
                hzsqyyid:"",
                hzstartTime:"",
                hzendTime:"",
                showClassList:{},
                platDocId:"",
                platHosId:"",
                platDocList:[],

                tpwjdzs:[],
                fjwjdzs:[],
            }
        },
        computed: {
            isAcceptDoc: function () {//判断登录用户是发起方还是受理方
                return this.consultDetail.consultGroup.acceptHosId === JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId;
            },
            consultId: function(){//获取会诊单编号
                return this.$route.params.consultId;//获取会诊单编号
            },
            refreshConsult: function() {// 动态检测是否完成会诊，进行重新刷新
                return this.$store.state.refreshConsultId == this.consultId;
            },
            consultStatus: function () {//会诊当前会诊单状态
                return this.consultDetail.consultGroup.consultStatus;
            },
            modifyName: function () {//最后处理人
                switch (this.consultDetail.consultGroup.modifierType){
                    case "DOC":
                        return this.consultDetail.consultGroup.acceptHosName+' - '+this.consultDetail.consultGroup.acceptDeptName+' - '+this.consultDetail.consultGroup.acceptDocName
                        break;
                    case "ASS":
                        return this.consultDetail.consultGroup.acceptAssName;
                        break;
                    case "PAT":
                        return this.consultDetail.pat.patName;
                        break;
                    default:
                        return '无';
                        break;
                }
            },
            videoTime: function () {//视频时间
                let video = this.consultDetail.consultGroup;
                if(video){
                    if(video.endTime){
                        return ('【'+this.formatUnix(video.consultTime)+'】'+' - '+'【'+this.formatUnix(video.endTime)+'】');
                    }else {
                        return ('【'+this.formatUnix(video.consultTime)+'】'+' - '+'【-】');
                    }
                }else {
                    return '【-】';
                }
            },
            acceptDoc: function () {//期望医生
                let consult = this.consultDetail.consultGroup;
                if(consult.hopeHosName&&consult.hopeDeptName){
                    if(consult.hopeDocName){
                        return consult.hopeHosName + ' - ' + consult.hopeDeptName + ' - ' + consult.hopeDocName;
                    }else {
                        return consult.hopeHosName + ' - ' + consult.hopeDeptName;
                    }
                }else {
                    return '无';
                }
            },
            upLoadList: function () {//获取上传图片和文件的id
                let imgUploadListArr = [];
                let fileUploadListArr = [];
                for(let i=0; i<this.imgUploadList.length; i++){
                    imgUploadListArr.push(this.imgUploadList[i].response.obj);
                }
                for(let i=0; i<this.fileUploadList.length; i++){
                    fileUploadListArr.push(this.fileUploadList[i].response.obj);
                }
                return this.adviceImgList.concat(imgUploadListArr, fileUploadListArr);
            }
        },
        created: function(){//创建时获取会诊单数据
            this.getConsultDetail();
        },
        watch: {
            // 如果路由有变化，会再次执行获取会诊单方法
            "$route": "getConsultDetail",
            "refreshConsult": function(newVal, oldVal) {// 如果补充了资料则重新刷新
                if(newVal === true){
                    this.getConsultDetail();
                    this.$store.dispatch("getRefreshConsultId", null);// 初始化需要刷新的id
                }
            },
        },
        components:{
            ConsultationSheet,
            ImageAmplify
        },
        mounted:function(){
            this.zzqk=this.$route.params.zzqk;
        },
        methods: {
            closeBoxs1:function(){
              let _this=this;
              _this.showBoxs1=false;
              _this.showBox=false;
            },
            showjpg:function(){
              let _this=this;
              _this.showBox3=true;
            },
            closeBox3:function(){
                let _this=this;
                _this.showBox3=false;
            },
            closeBox2:function(){
                let _this=this;
                _this.showBox2=false;
                _this.showBox6=false;
                _this.showBox=false;
            },
            closeBox4:function(){
                let _this=this;
                _this.showBox4=false;
                _this.showBox=false;
            },
            closeBox5:function(){
                let _this=this;
                _this.showBox5=false;
                _this.showBox=false;
            },
            getInitHospId: function(hospId){//获取选择申请的医院id
                let _this=this;
                _this.initHosId = hospId;
                for(var i=0;i<_this.hospListZ.length;i++){
                    if(_this.initHosId==_this.hospListZ[i].yyid){
                        _this.zyyymc=_this.hospListZ[i].yymc
                    }
                }
                _this.initDeptId = "";
                _this.initDocId = "";
                _this.getInitDeptList();
            },
            getInitDeptList: function(query){//获取申请科室列表
                if(this.initHosId){
                    this.loading = true;
                    let _this = this;
                    let options = {
                        yyid: _this.initHosId,
                        service: "smarthos.sxzz.outdept.list"
                    };
                    axiosUtilz(options, function(data){
                        _this.loading = false;
                        _this.initDeptList = data.list;
                    });
                }else{
                    Message({
                        showClose: true,
                        message: "请先选择医院",
                        type: "info"
                    });
                    return;
                }
            },
            getInitDeptId: function(deptId){// 获取申请科室id
                let _this=this;
                    _this.initDeptId = deptId;
                    for(var i=0;i<_this.initDeptList.length;i++){
                        if(_this.initDeptId==_this.initDeptList[i].ksid){
                            _this.zyksmc=_this.initDeptList[i].ksmc
                        }
                    }
                    _this.initDocId = "";
                    _this.getInitDocList();
            },
            getInitDocList: function(query){//获取医生列表
                if(this.initDeptId&&this.initHosId){//如果医院和科室已经选择完成则可以选择科室
                    this.loading = true;
                    let _this = this;
                    let options = {
                        yyid: _this.initHosId,
                        ksid: _this.initDeptId,
                        service: "smarthos.sxzz.outdoc.list"
                    };
                    axiosUtilz(options, function(data){
                        _this.loading = false;
                        _this.initDocList = data.list;
                    });
                }else{
                    Message({
                        showClose: true,
                        message: "请先选择科室",
                        type: "info"
                    });
                    return;
                }
            },
            getInitDocId: function(docId){//获取申请的医生id
                let _this=this;
                _this.initDocId = docId;
                for(var i=0;i<_this.initDocList.length;i++){
                    if(_this.initDocId==_this.initDocList[i].ysid){
                        _this.zyysxm=_this.initDocList[i].ysxm
                    }
                }

            },
            closeBox:function(){
                let _this=this;
                _this.showBox=false;
                _this.showBox1=false;
                _this.showBox6=false;
                _this.initHosId="";
                _this.initDeptId="";
                _this.initDocId="";

            },
            getHosTransfer1:function(){
                let _this=this;
                _this.showBoxs1=true;
                _this.showBox=true;
                let options = {
                    service: "smarthos.sxzz.mzhos.list"
                };
                axiosUtilz(options, function (data) {
                    _this.hospListZ = data.list;
                });
                let options1={
                    docId:_this.hzysid,
                    token: localStorage.getItem("token"),
                    Service:"smarthos.user.doc.card.get"
                }
                axiosUtil(options1,function(data){
                    _this.showClassList={
                        hzstartTime:formatUnixTime(_this.hzstartTime),
                        hzendTime:formatUnixTime(_this.hzendTime),
                        hzid:_this.consultId,
                        hzsj:formatUnixTime(_this.hzsj),
                        yhxm: _this.consulterName,
                        zjhm:_this.consulterIdcard,
                        kh:_this.kh,
                        zs:_this.zs,
                        hy:_this.hy,
                        lxdz:_this.lxdz,
                        sjhm:_this.consulterMobile,
                        zy: _this.consulterJob?_this.consulterJob:"",
                        zxyj:_this.consultAdvice,
                        areaNameArr:_this.areaNameArr,//省市区

                        sqyymc:_this.hzsqyymc,
                        sqyyid:_this.hzsqyyid,
                        sqksmc:_this.hzsqksmc,
                        sqysxm:_this.hzsqysxm,
                        ysid:_this.initDocId,
                        sqysid:JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,

                        yymc:_this.zyyymc,
                        yyid:'058202',
                        ksid:_this.initDeptId,

                        ksmc:_this.zyksmc,
                        ysxm:_this.zyysxm,

                        hzbqqq:_this.consultStatus1,
                        cbzd:_this.beforeDiagnose,
                        tpwjdzs:_this.tpwjdzs,
                        fjwjdzs:_this.fjwjdzs,
                        platDocList:data.obj.doc
                    }
                })
            },
            SureTransf1:function(){
                let _this = this;
                if(_this.initDeptId!=""){
                    _this.showBoxs1 = false;
                    _this.showBox = false;
                }else{
                    Message({
                        showClose: true,
                        message: "请选择科室",
                        type: "warning"
                    });
                    return
                }
                let options = {
                    docId: _this.hzysid,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.user.doc.card.get"
                }
                axiosUtil(options, function (data) {
                    _this.showClassList = {
                        hzstartTime: formatUnixTime(_this.hzstartTime),
                        hzendTime: formatUnixTime(_this.hzendTime),
                        hzid: _this.consultId,
                        hzsj: formatUnixTime(_this.hzsj),
                        yhxm: _this.consulterName,
                        zjhm: _this.consulterIdcard,
                        kh: _this.kh,
                        zs: _this.zs,
                        hy: _this.hy,
                        lxdz: _this.lxdz,
                        sjhm: _this.consulterMobile,
                        zy: _this.consulterJob ? _this.consulterJob : "",
                        zxyj: _this.consultAdvice,
                        areaNameArr: _this.areaNameArr,//省市区

                        sqyymc: _this.hzsqyymc,
                        sqyyid: _this.hzsqyyid,
                        sqksmc: _this.hzsqksmc,
                        sqysxm: _this.hzsqysxm,
                        ysid: _this.initDocId,
                        sqysid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,

                        yymc: _this.zyyymc,
                        // yyid: '058202',
                        yyid:_this.initHosId,

                        ksmc: _this.zyksmc,
                        ksid: _this.initDeptId,
                        ysxm: _this.zyysxm,

                        hzbqqq: _this.consulterDiagnoseLevel ,
                        cbzd: _this.beforeDiagnose,
                        tpwjdzs: _this.tpwjdzs,
                        fjwjdzs: _this.fjwjdzs,
                        platDocList: data.obj.doc
                    }
                    _this.$router.push({name:"showClassList",params:{showObj:_this.showClassList}});

                })
            },
            SureTransf:function(){
                let _this=this;
                if(_this.initDeptId!=""&&_this.initDocId!=""){
                    _this.showBoxs1 = false;
                    // _this.showBox = false;
                }else{
                    _this.showBoxs1 = true;
                    _this.showBox = true;
                    if(_this.initDeptId==""){
                        Message({
                            showClose: true,
                            message: "请选择科室",
                            type: "warning"
                        });
                        return
                    }else{
                        Message({
                            showClose: true,
                            message: "请选择医生",
                            type: "warning"
                        });
                        return
                    }
                }

                let service = "";
                if(_this.showBox6){//住院转诊
                    service = "smarthos.sxzz.hzzyzz.info"
                }else if(_this.showBox1){//急诊转诊
                    service = "smarthos.sxzz.hzzz.info"
                }

                let options={
                     hzstartTime:formatUnixTime(_this.hzstartTime),
                     hzendTime:formatUnixTime(_this.hzendTime),
                     hzid:_this.consultId,
                     lxdz:  _this.lxdz,
                     hzsj:formatUnixTime(_this.hzsj),
                     yhxm: _this.consulterName,
                     zjhm:_this.consulterIdcard,
                     kh:_this.kh,
                     areaNameArr:_this.areaNameArr,
                     sjhm:_this.consulterMobile,
                     zy: _this.consulterJob?_this.consulterJob:"",
                     zxyj:_this.consultAdvice,
                     hy:_this.hy,
                     zs:_this.zs,
                     zd: _this.evaluateData.afterDiagnose,

                     sqyymc:_this.hzsqyymc,
                     sqyyid:_this.hzsqyyid,
                     sqksmc:_this.hzsqksmc,
                     sqysxm:_this.hzsqysxm,
                     sqysid:JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,

                     yymc:_this.zyyymc,
                     yyid:_this.initHosId,
                     ksmc:_this.zyksmc,
                     ksid:_this.initDeptId,
                     ysxm:_this.zyysxm,
                     ysid:_this.initDocId,

                     cbzd:_this.beforeDiagnose,
                     tpwjdzs:_this.tpwjdzs,
                     fjwjdzs:_this.fjwjdzs,
                     service:service,
                 };
                _this.showClassList=_this.options;
                axiosUtilz(options,function(data){
                    if(data.code=="1"){
//                        建档成功
                        _this.showBox=true;
                        _this.showBox2=true;
                        _this.showBox1=false;
                        _this.showBox6=false;
                        _this.zzqk=data.obj.zzqk;
                        _this.bah=data.obj.bah;
                    }else if(data.code=="3"){
//                        建档失败，实名认证失败
                        _this.showBox=true;
                        _this.showBox4=true;
                        _this.showBox1=false;
                        _this.showBox6=false;
                        _this.zzqk=data.obj.zzqk;
                        _this.bahms=data.obj.bahms;
                    }else if(data.code=="2"){
//                        已经建档
                        _this.showBox=true;
                        _this.showBox5=true;
                        _this.showBox1=false;
                        _this.showBox6=false;
                        _this.zzqk=data.obj.zzqk;
                        _this.bah=data.obj.bah;
                    }
                },function(err){
                    _this.showBox=false;
                    _this.showBox6=false;
                    _this.showBox1=false;


                })
            },
            getHosTransfer:function(){
                let _this=this;
                _this.showBox=true;
                _this.showBox1=true;
                let options={
                    service:"smarthos.sxzz.mzhos.list"
                };
                axiosUtilz(options,function(data){
                    _this.hospListZ=data.list;
                })
            },
            getHosTransfer2:function(){
                let _this=this;
                _this.showBox=true;
                _this.showBox6=true;
                let options={
                    service:"smarthos.sxzz.mzhos.list"
                };
                axiosUtilz(options,function(data){
                    _this.hospListZ=data.list;
                })
            },
            getrecord:function(){
                let _this=this;
            },
            linkToCx:function(){
                let _this=this;
                if(_this.consulterIdcard!=""){
                    let options={
                        idCard:_this.consulterIdcard,
                        token: localStorage.getItem("token"),
                        Service:"smarthos.book.emr.patient"
                    }
                    axiosUtil(options,function(data){
                        if(data.list){
                            if(data.list.length>0){
                                window.localStorage.setItem("patInfo", JSON.stringify(data.list[0]));
                                window.open("./?from=ins#/linkCx");
                            }else{
                                Message({
                                    showClose: true,
                                    message: "该身份证号在长兴医院没有病历",
                                    type: "warning"
                                });
                            }
                        }else{
                            Message({
                                showClose: true,
                                message: "该身份证号在长兴医院没有病历",
                                type: "warning"
                            });
                        }
                    })
                }else{
                    Message({
                        showClose: true,
                        message: "请输入18位身份证号",
                        type: "warning"
                    });
                }
            },
            Transfer:function(){
                let _this=this;
                if(_this.evaluateData.transfer=="1"){
                    _this.showTranfer=true;
                }else{
                    _this.showTranfer=false;
                }
            },
            PasWord: function () {
                let options = {
                    'Service': "smarthos.system.atta.upload"
                };
                return upLoadBasicParam.sign
            },
            formatUnix: function (time) {//将unix时间戳转换未yyyy-MM-dd HH:mm
                return formatUnixTime(time);
            },
            getConsultDetail: function () {//根据consultId获取会诊单数据
                let _this = this;
                if(_this.$route.params.zzqk){
                    _this.zzqk=_this.$route.params.zzqk;
                    return
                }else{
                    let options = {
                        consultId: _this.consultId,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.detail"
                    };
                    axiosUtil(options, function (data) {

                        _this.isSuccess = true;
                        if(_this.mark=='accept'){//上级医院显示转诊按钮
                            if(data.obj.consultGroup.transfer==true){
                                _this.transFer="0";
                            }else{
                                _this.transFer="1";
                            }
                        }else{//下级医院不显示转诊按钮
                            _this.transFer="";
                        }
                        // _this.transFer=data.obj.consultGroup.transFer;

                        _this.consulterDiagnoseLevel=data.obj.consultGroup.consulterDiagnoseLevel;
                        _this.consultStatusDescription=data.obj.consultStatusDescription;
                        if(data.obj.consultGroup.medicalScore){

                            _this.zt=true;
                        }
                        _this.areaNameArr=data.obj.areaNameArr;
                        _this.hzysid=data.obj.consultGroup.acceptDocId;
                        _this.hzstartTime=data.obj.consultGroup.startTime;
                        _this.hzendTime=data.obj.consultGroup.endTime;
                        _this.zs=data.obj.consultGroup.consultContent;
                        _this.hzsqyyid=data.obj.consultGroup.initHosId;
                        _this.hzsj=data.obj.consultGroup.consultTime;
                        _this.hy=data.obj.consultGroup.maritalStatus;
                        _this.lxdz=data.obj.consultGroup.consulterAddress;
                        _this.hzysxm=data.obj.consultGroup.acceptDocName;
                        _this.hzksmc=data.obj.consultGroup.acceptDeptName;
                        _this.hzyymc=data.obj.consultGroup.acceptHosName;
                        _this.hzsqysxm=data.obj.consultGroup.initDocName;
                        _this.hzsqksmc=data.obj.consultGroup.initDeptName;
                        _this.hzsqyymc=data.obj.consultGroup.initHosName;
                        _this.beforeDiagnose=data.obj.consultGroup.beforeDiagnose;
                        _this.consulterJob=data.obj.consultGroup.consulterJob;
                        _this.zzqk=data.obj.consultGroup.referralSituation;
                        _this.consulterMobile=data.obj.consultGroup.consulterMobile;
                        _this.consulterName=data.obj.consultGroup.consulterName;
                        _this.consultDetail = data.obj;
                        if (data.obj.consultGroup.maritalStatus=="0") {
                            _this.maritalStatus="未婚";
                        }else if(data.obj.consultGroup.maritalStatus=="1"){
                            _this.maritalStatus="已婚";
                        }else if(data.obj.consultGroup.maritalStatus=="2"){
                            _this.maritalStatus="离异";
                        }else if(data.obj.consultGroup.maritalStatus=="3"){
                            _this.maritalStatus="不详";
                        }
                        _this.kh=_this.consultDetail.consultGroup.consulterInhosno
                        _this.consulterIdcard = data.obj.consultGroup.consulterIdcard;//患者证件号
                        _this.getrecord();
                        _this.selectDate = data.obj.consultGroup.consultTime;
                        _this.acceptId = data.obj.consultGroup.acceptHosId;
                        _this.consultAdvice = data.obj.consultGroup.consultAdvice || "";
                        _this.evaluateData.afterDiagnose = data.obj.consultGroup.afterDiagnose || "";
                        //获取附件并分组图片和文件
                        _this.fileList = [];//清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
                        _this.imgList = [];//清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
                        _this.adviceImgList = [];
                        _this.adviceFileList = [];
                        fileClassification(data.obj.attaList, _this.imgList, _this.fileList);
                        fileClassification(data.obj.adviceAttaList, _this.adviceImgList, _this.adviceFileList);// 获取咨询意见附件
                        _this.tpwjdzs=_this.imgList;
                        _this.fjwjdzs=_this.fileList;
                        _this.uploadFileCount = _this.adviceImgList.length;
                        //判断是否有评价记录
                        if (data.obj.consultGroup.recordScore) {
                            let evalData = data.obj.consultGroup;
                            _this.evaluateData.equalDiagnose = evalData.equalDiagnose ? '1' : '0';
                            _this.evaluateData.transfer = evalData.transfer ? '1' : '0';
                            if(_this.evaluateData.transfer=="1"){
                                _this.showTranfer=true;
                            }
                            if (evalData.systemScore) {//发起方的评价，可能已经评价，可能未评价，需要判断
                                _this.evaluateData.systemScore = evalData.systemScore;
                            }
                            _this.evaluateData.medicalScore = evalData.medicalScore;
                            _this.evaluateData.recordScore = evalData.recordScore;
                            _this.evaluateData.pastHistoryScore = evalData.pastHistoryScore;
                            _this.evaluateData.afterDiagnose = evalData.afterDiagnose;
                        }
                        //判断是发起方还是受理方
                        let ss = JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId;

                        if (ss != "") {
                            if (ss == _this.acceptId) {
                                _this.shows6 = true;
                                _this.isAdviseds =false;
                            } else {
                                _this.shows6 = false;
                                _this.isAdviseds =true;
                            }
                        }
                    }, function () {
                        _this.isSuccess = true;
                        _this.$router.go(-1);
                    });
                }
            },
            handleImageAmplify: function (index = 1, imgList = [], ev) {//图片放大
                let e = ev || event;
                let element = e.target || e.srcElement;
                let src = element.src;
                let obj = {
                    imgList: imgList,
                    index: index
                };
                this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
                imageAmplify(src);
            },
            beforeUpload: function (file) {//上传图片/文件前钩子函数
                let _this = this;
                if (_this.uploadFileCount < upLoadFileCountMax) {//如果上传数量小于9
                    _this.uploadFileCount++;
                    return new Promise(function (resove, reject) {
                        _this.uploadData = Object.assign({
                            'file': file,
                            'module':'CONSULT_GROUP',
                            'fileType':"IMAGE",
                            'Service': "smarthos.system.file.upload"
                        }, upLoadBasicParam);
                        resove(true);
                    });
                } else {
                    _this.uploadFileCount++;// 如果返回false，则会调用移除图片函数 ，uploadFileCount会减1
                    Message({
                        showClose: true,
                        message: "上传图片数量不能多于9张",
                        type: "info"
                    });
                    return false;
                }
            },
            beforeUploadFile: function(file){//上传文件前钩子函数
                let _this = this;
                let maxsize=1024*600;
                let type= file.name.replace(/.+\./,"")
                if(type=="RAR"||type=="pdf"||type=="xls"||type=="xlsx"||type=="doc"||type=="docx"||type=="txt"||type=="rar"||type=="zip"||type=="PDF"){
                }else{
                    Message({
                        showClose: true,
                        message:"不支持该类型文件上传",
                        type: "error"
                    })
                    return false;
                }
                if(file.size/1024>maxsize){
                    Message({
                        showClose: true,
                        message:"附件大小不能大于500mb",
                        type: "error"
                    })
                    return false;
                }else{
                    return new Promise(function (resove, reject) {
                        _this.uploadData = Object.assign({
                            'file': file,
                            'module':'CONSULT_GROUP',
                            'fileType':"OTHER",
                            'Service': "smarthos.system.file.upload"
                        }, upLoadBasicParam);
                        resove(true);
                    });
                }
                /*1.2.3版本return false 还是会增加item项，所以增加如下一句代码， 下个elementui版本会修复，升级版本需要删除此行代码。 需在upload上加ref='uploadRef'*/
                //_this.$refs.uploadRef.uploadFiles.pop();
            },
            onSuccessImg: function (response, file, fileList) {//上传图片成功后钩子
                if (response.succ) {
                    this.imgUploadList = fileList;
                } else {
                    Message({
                        showClose: true,
                        message: response.msg,
                        type: "error"
                    });
                }
            },
            onSuccessFile: function(response, file, fileList){//上传文件成功后钩子
                if(response.succ){
                    this.fileUploadList = fileList;
                }else {
                    Message({
                        showClose: true,
                        message: response.msg,
                        type: "error"
                    });
                }
            },
            onRemoveFile: function (file, fileList) {//删除上传文件
                this.fileUploadList = fileList;
            },
            onRemoveImg: function (file, fileList) {//删除上传图片
                if (this.uploadFileCount > 0) {//数量减1
                    this.uploadFileCount--;
                }
                this.imgUploadList = fileList;
            },
            handlePreview: function (file) {//上传的图片放大
                let obj = {
                    imgList: [],
                    index: 0
                };
                this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
                imageAmplify(file.url);
            },
            submitEvaluate: function () {
                let _this = this;
                _this.submits = true;
                for (let i = 0; i < _this.upLoadList.length; i++) {
                    _this.attaIdList.push(_this.upLoadList[i].id);
                }
                let options = null;
                if (_this.isAcceptDoc){//受理方评价
                    options = {
                        consultId: _this.consultId,
                        consulterDiagnoseLevel:_this.consulterDiagnoseLevel,
                        transfer: _this.transfer,
                        attaIdList: _this.attaIdList,
                        consultAdvice:_this.consultAdvice,
                        afterDiagnose:_this.evaluateData.afterDiagnose,
                        referralSituation:_this.zzqk?_this.zzqk:"",
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.advice"
                    }
                } else {
                    options = {
                        consultId: _this.consultId,
                        systemScore: _this.evaluateData.systemScore,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.comment"
                    };
                }
                axiosUtil(options, function (data) {
                    _this.submits = false;
                    Message({
                        showClose: true,
                        message: "提交成功",
                        type: "success"
                    });
                    _this.$router.push("/main/RemoteConsulations");
                    _this.evaluateData.equalDiagnose = data.obj.equalDiagnose;
                    _this.evaluateData.systemScore = data.obj.systemScore;
                    _this.evaluateData.medicalScore = data.obj.medicalScore;
                    _this.evaluateData.recordScore = data.obj.recordScore;
                    _this.evaluateData.pastHistoryScore = data.obj.pastHistoryScore;

                }, function () {
                    _this.submits = false;
                });
            },
            toEvaluate:function () {
              let _this = this;
              _this.showBox = true;
              _this.showPj = true;
            },
            evaluateView(){
              let _this = this;
                _this.showBox = true;
                _this.showPj2 = true;
            },
            cancelEvaluate:function () {
                let _this = this;
                _this.showBox = false;
                _this.showPj = false;
                _this.showPj2 = false;
            },
            submitEvaluate1: function () {
                let _this = this;
                _this.submits1 = true;
                for (let i = 0; i < _this.upLoadList.length; i++) {
                    _this.attaIdList.push(_this.upLoadList[i].id);
                }
                let options = null;
                if (_this.isAcceptDoc){//受理方评价
                    options = {
                        consultId: _this.consultId,
                        equalDiagnose: _this.evaluateData.equalDiagnose,
                        medicalScore: _this.evaluateData.medicalScore,
                        recordScore: _this.evaluateData.recordScore,
                        pastHistoryScore: _this.evaluateData.pastHistoryScore,
                        systemScore: _this.evaluateData.systemScore,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.advice"
                    }
                } else {//
                    options = {
                        consultId: _this.consultId,
                        systemScore: _this.evaluateData.systemScore,
                        token: localStorage.getItem("token"),
                        Service: "smarthos.consult.group.comment"
                    };
                }
                axiosUtil(options, function (data) {
                    _this.submits1 = false;
                    Message({
                        showClose: true,
                        message: "提交成功",
                        type: "success"
                    });
                    _this.showPj = false;
                    _this.showBox = false;
                    _this.pjRes = true;
                    _this.consultDetail.consultGroup.recordScore=data.obj.recordScore
                    _this.consultDetail.consultGroup.systemScore=data.obj.systemScore
                    // _this.$router.push({path:"/main/RemoteConsulations",name:"RemoteConsulations",params:{tab:"finished"}});
                }, function () {
                    _this.submits1 = false;
                });
            }
        }
    }
</script>
